/* eslint-disable i18next/no-literal-string --
 * React Query cache keys.
 */
/**
 * `entities/taxonomy-campaign` TanStack Query key factory.
 *
 * Surface:
 *   - `TAXONOMY_CAMPAIGN_QUERY_KEYS.all`  → `['taxonomy-campaigns']`
 *   - `….list()`                          → `['taxonomy-campaigns', 'list']`
 *
 * No `detail`: nothing fetches one campaign on its own. The list is small,
 * always loaded by the page that needs it, and a single campaign is read out of
 * it rather than re-requested.
 */
export const TAXONOMY_CAMPAIGN_QUERY_KEYS = {
  all: ['taxonomy-campaigns'] as const,

  list: () => [...TAXONOMY_CAMPAIGN_QUERY_KEYS.all, 'list'] as const,
} as const;
